import { type VariantProps } from 'class-variance-authority';
import { cn } from '@avanta/shared/utils/cn';
import { Text } from '../../Text';
import { cardVariants } from './styles';

export interface CardProps extends React.ComponentProps<'div'>, VariantProps<typeof cardVariants> {
  title?: string;
  icon?: React.ElementType;
}

export const Card = ({
  className,
  title,
  icon: Icon,
  variant,
  withoutBorder = false,
  children,
  ...props
}: React.PropsWithChildren<CardProps>): React.ReactElement => (
  <div className="flex flex-col gap-3 flex-1 items-center">
    {title && (
      <div className="flex items-center gap-2 w-full">
        {Icon && <Icon className="size-8 shrink-0 text-denim-800" strokeWidth={1.5} />}
        <Text
          tag="h3"
          variant="heading-md-medium"
          className="text-base leading-5 text-denim-800 am-3xl:text-lg"
        >
          {title}
        </Text>
      </div>
    )}
    <div
      data-slot="card"
      className={cn(cardVariants({ variant, withoutBorder }), className)}
      {...props}
    >
      {children && <div data-slot="card-content">{children}</div>}
    </div>
  </div>
);
